import { Button } from './ui/button'
import { Card, CardContent, CardFooter } from './ui/card'
import { Badge } from './ui/badge'
import { Star, Plus } from 'lucide-react'
import { ImageWithFallback } from './figma/ImageWithFallback'
import { CatalogItem } from '../types/catalog';

export interface ProductCardProps {
  product: CatalogItem;
}
export interface Tire {
  id: string
  name: string
  brand: string
  season: string
  price: number
  originalPrice?: number
  rating: number
  reviewCount: number
  size: string
  width: number
  height: number
  radius: number
  features: string[]
  imageUrl: string
  inStock: boolean
}

interface TireCardProps {
  tire: CatalogItem
  onAddToCart: (tire: CatalogItem) => void
}
function seasonfn(seasonsymbol:string) {
        switch (seasonsymbol) {
            case "w":
                return 'https://img.intershina.pro/images/snow.svg';
            case "s":
                return 'https://img.intershina.pro/images/summer.svg';
            case "u":
                return 'https://img.intershina.pro/images/allseason.svg';
            default:
                return 'https://img.intershina.pro/images/allseason.svg';
        }
    };
export function TireCard({ tire, onAddToCart }: TireCardProps) {
  const discount = 0
  const kv: Record<string, string> = Object.fromEntries(
    (tire.props?.prop ?? []).map(p => [p.code, p.value])
  );
  let features:Array<string>=new Array;
  const brand = kv['brand'] || '';
  const width = kv['width'] || '';
  const height = kv['height'] || kv['profile'] || '';
  const diameter = kv['diameter'] || '';
  const season = kv['season'] || '';
  const thorn = kv['thorn'] || false;
  const load_index=kv['load_index']||'';
  const speed_index=kv['speed_index']||'';
  const constr=kv['constr']||'';
  const price=kv['price']||'-';
  const qty=tire.qty|| 0;
  const inStock =(qty) > 3 && ("В наличии")|| (qty)>0 && (qty)||("Под заказ");
  const seasonurl=seasonfn(season);
  const pic=(tire.pic!='')&&(tire.pic)||(kv['img_big_my']);
  features.push(load_index+speed_index);
  features.push(constr);
  const sizeLabel =
    width && height && diameter
      ? `${width}/${height} R${diameter}`
      : tire.title || '';

  return (
    <Card className="hover:shadow-lg transition-shadow duration-200">
      <CardContent className="p-4">
        <div className="relative mb-4">
          {discount > 0 && (
            <Badge className="absolute top-2 left-2 bg-[#ed8510] text-white hover:bg-[#d97009]">
              -{discount}%
            </Badge>
          )}
          <ImageWithFallback
            src={pic}
            alt={tire.name}
            
            className="w-full h-48 object-cover rounded-md"
          />
        </div>
        
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Badge variant="outline" className="text-xs border-[#ed8510] text-[#ed8510]">
             <img src={seasonurl}></img>
              {thorn=="true" && (
              <img              
              src="https://img.intershina.pro/images/thorn.svg"
              alt="Шипы"
                />
              )}
            </Badge>
            <Badge variant={kv['inStock'] ? "default" : "secondary"} className={kv['inStock']!='Под заказ' ? "text-xs bg-[#ed8510] hover:bg-[#d97009]" : "text-xs"}>
              {inStock}
            </Badge>
          </div>
          
          <h3 className="font-semibold text-lg product-name">{tire.name}</h3>
          <p className="text-sm text-gray-600">{brand}</p>
          <p className="text-sm font-medium text-[#ed8510]">{sizeLabel}</p>
          <div className="flex flex-wrap gap-1">
            {features.map((feature, index) => (
              <Badge key={index} variant="outline" className="text-xs border-[#ed8510]/30 text-[#ed8510]">
                {feature}
              </Badge>
            ))}
          </div>
        </div>
      </CardContent>
      
      <CardFooter className="p-4 pt-0">
        <div className="w-full">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <span className="text-xl font-bold text-[#ed8510]">{tire.price}₽</span>
            </div>
          </div>
          
          <Button 
            className="w-full bg-[#ed8510] hover:bg-[#d97009] text-white" 
            onClick={() => onAddToCart(tire)}
          >
            <Plus className="h-4 w-4 mr-2" />
            В корзину
          </Button>
        </div>
      </CardFooter>
    </Card>
  )
}